import { Gamecloud } from "../../../gamecloud"
import { createGameserverStateUIInstances, GameserverStateUI } from "./gameserverStateUI";
import Axios, {AxiosResponse} from "../../../../../../../../../node_modules/axios";
import { Notification } from "../../../../notification/notfication";
import { connect } from 'socket.io-client';
import {IStartGameserverResponse} from "../../../interface";

class GameserverState extends Gamecloud {

  public constructor(private ui: GameserverStateUI) {
    super();

    window.addEventListener('socketData', (event: CustomEvent) => {
      if (event.detail.type == 'stateChanged') {
        this.ui.updateUI(event.detail.data.state);
      }
      this.ui.showInstalling(event.detail.data.details);
    });

    this.bind();
  }

  private bind() {
    this.ui.onRestartClick(this.restart.bind(this));
    this.ui.onSelectChange(this.toggle.bind(this))
  }

  private toggle() {
    this.loader.enable();
    this.ui.disableSwitch();

    if (this.ui.isChecked()) {
      this.goOffline();
    } else {
      this.goOnline();
    }
  }

  private goOffline() {
    this.loader.enable();
    this.ui.disableReinstallServer(true);
    Axios.get(this.ui.getStopURL(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(() => {
      this.loader.disable();
      this.ui.disableReinstallServer(false);
      new Notification('success', 'Done', 'Your server will stop now');
    }).catch(() => {
      this.ui.disableReinstallServer(false);
      new Notification('danger', 'Ooops!', 'Something went wrong. Please try again later.');
    });
  }

  private goOnline() {
    this.loader.enable();
    this.ui.disableReinstallServer(true);
    Axios.get(this.ui.getStartURL(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response : AxiosResponse<IStartGameserverResponse>) => {
      this.loader.disable();
      this.ui.disableReinstallServer(false);
      
      if(response.data.result === true) {
        new Notification('success', 'Done', 'Your server will start now');
      }
      else {
        let message : string = 'Something went wrong. Please try again later';
    
        if(response.data.message.length)
          message = response.data.message;
    
        new Notification('success', 'Done', message);
      }
    }).catch(() => {
      this.ui.disableReinstallServer(false);
      new Notification('danger', 'Ooops!', 'Something went wrong. Please try again later.');
    });
  }

  private restart(event? : JQuery.TriggeredEvent) {
    this.loader.enable();
    this.ui.disableSwitch();
    this.ui.disableReinstallServer(true);
    
    Axios.get(this.ui.getRestartURL(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response : AxiosResponse<IStartGameserverResponse>) => {
      this.loader.disable();
      this.ui.disableReinstallServer(false);
      
      if(response.data.result === true) {
        new Notification('success', 'Done', 'Your server will restarting now');
      }
      else {
        let message : string = 'Something went wrong. Please try again later';
        
        if(response.data.message.length)
          message = response.data.message;
  
        new Notification('success', 'Done', message);
      }
    }).catch(() => {
      this.ui.disableReinstallServer(false);
      new Notification('danger', 'Ooops!', 'Something went wrong. Please try again later.');
    });
    
    if(event !== null) {
      event.stopPropagation();
    }
  }

}

export function initGameserverState() {
  return createGameserverStateUIInstances().map((ui: GameserverStateUI) => {
    return new GameserverState(ui);
  });
}
